// Libraries
import React from 'react';

// Supermove
import {Loading, Styled} from '@supermove/components';
import {gql} from '@supermove/graphql';
import {usePropUpdatedAt} from '@supermove/hooks';

// App
import Navigation from 'modules/App/components/Navigation';
import Page from 'modules/App/components/Page';
import PageLoadingIndicator from 'modules/App/components/PageLoadingIndicator';
import ProjectNotFoundPage from 'modules/Project/components/ProjectNotFoundPage';

const Container = Styled.View`
  flex: 1;
`;

const ProjectPageWithNavigationContent = ({
  theme,
  side,
  title,
  subtitle,
  onClose,
  children,
  ...props
}: any) => {
  const {updatedAt: loadingUpdatedAt} = usePropUpdatedAt(props.loading);

  return (
    <Container>
      <Navigation
        theme={theme}
        side={side}
        title={title({...props})}
        subtitle={subtitle({...props})}
        left={() =>
          onClose ? (
            <Navigation.CloseButton theme={theme} onPress={() => onClose({...props})} />
          ) : null
        }
      />
      <Loading as={PageLoadingIndicator} loading={props.loading}>
        {() =>
          props.data.project ? children({loadingUpdatedAt, ...props}) : <ProjectNotFoundPage />
        }
      </Loading>
    </Container>
  );
};

type OwnProjectPageWithNavigationProps = {
  hasActions?: boolean;
  theme?: string;
  onClose?: (...args: any[]) => any;
  side?: (...args: any[]) => any;
  title?: (...args: any[]) => any;
  subtitle?: (...args: any[]) => any;
};

// @ts-expect-error TS(2456): Type alias 'ProjectPageWithNavigationProps' circul... Remove this comment to see the full error message
type ProjectPageWithNavigationProps = OwnProjectPageWithNavigationProps &
  typeof ProjectPageWithNavigation.defaultProps;

// @ts-expect-error TS(7022): 'ProjectPageWithNavigation' implicitly has type 'a... Remove this comment to see the full error message
const ProjectPageWithNavigation = ({
  theme,
  side,
  title,
  subtitle,
  variables,
  query,
  onClose,
  pollInterval,
  children,
}: ProjectPageWithNavigationProps) => {
  return (
    <Page
      fetchPolicy={'network-only'}
      query={query}
      pollInterval={pollInterval}
      variables={variables}
    >
      {(props: any) => (
        <ProjectPageWithNavigationContent
          theme={theme}
          side={side}
          title={title}
          subtitle={subtitle}
          onClose={onClose}
          children={children}
          {...props}
        />
      )}
    </Page>
  );
};

ProjectPageWithNavigation.defaultProps = {
  hasActions: false,

  theme: 'light',
  onClose: undefined,

  side: ({responsive}: any) => (responsive.mobile ? 60 : 120),
  title: () => '',
  subtitle: () => '',
};

// --------------------------------------------------
// Data
// --------------------------------------------------
ProjectPageWithNavigation.fragment = gql`
  fragment ProjectPageWithNavigation on Project {
    id
  }
`;

export default ProjectPageWithNavigation;
